<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="edit">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <h4 class="modal-title">{{form.modal.title}}</h4>
        </div>
        <div class="modal-body">
          <form @submit.prevent="form.onSubmit" @keydown="form.errors.clear($event.target.id)">
            <input type="hidden" name="id" v-model="form.data.id">

            <div class="form-group" :class="{'has-error': form.errors.has('sampleNumber') }">
              <label class="control-label">Sample #</label>
              <input type="text" class="form-control" id="sampleNumber" v-model="form.data.sampleNumber" readonly>
              <span class="help-block" v-if="form.errors.has('sampleNumber')" v-text="form.errors.get('sampleNumber')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('siteName') }">
              <label class="control-label">Site Name</label>
              <input type="text" class="form-control" id="siteName" v-model="form.data.siteName" readonly>
              <span class="help-block" v-if="form.errors.has('siteName')" v-text="form.errors.get('siteName')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('location') }">
              <label class="control-label">Location</label>
              <input type="text" class="form-control" id="location" v-model="form.data.location" readonly>
              <span class="help-block" v-if="form.errors.has('location')" v-text="form.errors.get('location')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('idDate') }">
              <label class="control-label">Id Date</label>
              <date-picker v-model="form.data.idDate"></date-picker>
              <span class="help-block" v-if="form.errors.has('idDate')" v-text="form.errors.get('idDate')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('identifiedBy') }">
              <label class="control-label">Identified By <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="identifiedBy" v-model="form.data.identifiedBy">
              <span class="help-block" v-if="form.errors.has('identifiedBy')" v-text="form.errors.get('identifiedBy')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('workStatus') }">
              <label class="control-label">Work Status</label>
              <select class="form-control" v-model="form.data.workStatus">
                <option v-for="item in workStatus">{{item}}</option>
              </select>
              <span class="help-block" v-if="form.errors.has('workStatus')" v-text="form.errors.get('workStatus')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('species') }">
              <label class="control-label">Mosquito Species <span class="optional">(optional)</span></label>
              <div v-for="(species, index) in form.data.species">
                <div class="input-group">
                  <span class="input-group-addon">{{index + 1}}</span>
                  <select class="form-control" v-model="form.data.species[index]['mosquito']" placeholder="Mosquito Species">
                    <option></option>
                    <option v-for="m in mosquitoes" v-bind:value="m.id">{{m.attributes.name}}</option>
                  </select>
                  <input type="text" v-model="form.data.species[index]['count']" class="form-control" placeholder="(Mosquito Count)">
                  <span class="input-group-addon"><i class="fa fa-trash pointer" v-on:click="removeMosquito(index)" title="Remove mosquito"></i></span>
                </div>
              </div>
              <button type="button" class="btn btn-small" v-on:click="addMosquito()" title="Add contract"><i class="fa fa-plus"></i></button>
              <span class="help-block" v-if="form.errors.has('contracts')" v-text="form.errors.get('contracts')"></span>
            </div>


            <loading-button :loading="form.loading" class="btn btn-primary" :disabled="form.errors.any()">Save</loading-button>
            <button type="button" class="btn btn-default" data-dismiss="modal">cancel</button>
          </form>
        </div>
        <div class="modal-footer">
        </div>
      </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
  </div><!-- /.modal -->
</template>

<script>
  import LoadingButton from '@/components/loading-button';
  import DatePicker from '@/components/date-picker';

  export default {
    name: 'larval-identification-form',

    props: ['form'],

    components: {
      LoadingButton,
      DatePicker
    },

    computed: {
      mosquitoes() {
        return this.$store.getters.mosquitoSpecies;
      },
      workStatus() {
        return this.$store.getters.workStatus;
      },
    },

    methods: {
      addMosquito() {
        if (typeof(this.form.data.species) !== 'object') {
          this.form.data.species = [];
        }

        this.form.data.species.push({mosquito: null, count: null});
        this.$forceUpdate();
      },

      removeMosquito(index) {
        this.$forceUpdate();
        this.form.data.species.splice(index, 1);
      }
    }

  }

</script>